var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"ml-2 pl-3 pr-3 bg-purple-500 text-white p-1 rounded-full flex items-center hover:text-white",staticStyle:{"height":"20px"},attrs:{"to":"/administration/membership"}},[_c('span',{staticClass:"font-bold",staticStyle:{"font-size":"12px"}},[_vm._v("Pro")])])
}
var staticRenderFns = []

export { render, staticRenderFns }